import {Link} from "react-scroll";

const MenuPhoto = () => {
    return(
        <div className="menuphoto grid min-[320px]:grid-cols-1 xl:grid-cols-2">

            <div className="menuphoto-2">
                <Link to="corporate" offset={-100} spy={true} smooth={true} duration={500}>
                    <img src={require('../img/img-corpo.jpg')} alt="Corporate"/>
                    <p className="menuphoto-2-title text-f-40">Corporate</p>
                    <a className="menuphoto-2-link  text-f-24" href="/photo">Voir les réalisations</a>
                </Link>
            </div>

            <div className="menuphoto-3">
                <Link to="evenements" offset={-100} spy={true} smooth={true} duration={500}>
                    <img src={require('../img/img-events.jpg')} alt="Evenements"/>
                    <p className="menuphoto-3-title text-f-40">Évenements</p>
                    <a className="menuphoto-3-link text-f-24" href="/photo">Voir les réalisations</a>
                </Link>
            </div>
        </div>
    )

}
export default MenuPhoto;